/* import __COLOCATED_TEMPLATE__ from './group.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./group.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());